import { Field, getIn, useFormikContext } from 'formik'
import React, { ReactNode, useCallback, useEffect, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { SelectField } from '../../field'
import { useSettings } from '../../../../../containers/Parameters'

interface Props {
  name: string
  label?: string
  onChange?: (arg?: string | number) => void
  required?: boolean
  clearable?: boolean
  searchable?: boolean
  placeholder?: string
  children?: ReactNode
  disabled?: boolean
}

export const StationInput: React.FC<Props> = ({
  clearable,
  name,
  label,
  onChange,
  placeholder,
  required,
  searchable,
  disabled = false,
}) => {
  const intl = useIntl()
  const validate = useCallback(
    (value: string | number | null): string | undefined => {
      if (required && !value) {
        return intl.formatMessage({ id: 'validation.requiredField' })
      }
      return undefined
    },
    [required, intl]
  )

  const settings = useSettings()
  const { values, setFieldValue } = useFormikContext<any>()

  const stations: any[] = useMemo(() => settings?.stations
    .filter((station: any) => station.type === 1 || station.type === 2)
    .map((station: any) => ({
      label: station.name,
      value: station.id,
    })) || [], [settings?.stations])

  

  useEffect(() => {
    if (stations.length === 1 && !getIn(values, name)) {
      const value = stations[0].value
      setFieldValue(name, value)
      if (onChange) onChange(value)
    }
  }, [name, onChange, stations, values, setFieldValue]) 

  return (
    <Field
      disabled={disabled}
      clearable={clearable}
      component={SelectField}
      id={name}
      name={name}
      label={label}
      required={required}
      validate={validate}
      onChange={onChange}
      searchable={searchable}
      placeholder={placeholder}
      options={stations}
    />
  )
}
